// Extractions in itself. It's like a container.
import { productBundleExtractionsService } from '@/services/estimation/product-bundle-extractions.service';
import axios from 'axios';

const initialState = () => ({
  productBundleExtractions: [],
  initiateResetProductBundleExtraction: false,
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const CancelToken = axios.CancelToken;
let cancelTokens = {
  productBundleExtractionsSearch: null,
};

const actions = {
  // Get extractions (using some filters)
  searchProductBundleExtractions({ commit }, { authorId, opportunityId, opportunityDocumentId, status }) {
    if (cancelTokens.productBundleExtractionsSearch) {
      cancelTokens.productBundleExtractionsSearch.cancel('Multiple requests.');
    }
    cancelTokens.productBundleExtractionsSearch = CancelToken.source();

    commit('SEARCH_EXTRACTIONS');
    return productBundleExtractionsService
      .searchProductBundleExtractions({
        authorId,
        opportunityId,
        opportunityDocumentId,
        status,
        cancelToken: cancelTokens.productBundleExtractionsSearch,
      })
      .then(
        (response) => {
          commit('SUCCESS', response);
        },
        (error) => {
          if (axios.isCancel(error)) return;
          commit('ERROR', error.response);
          throw error;
        },
      );
  },
  // Add a new extraction
  addProductBundleExtraction(
    { commit },
    { name, opportunityDocumentId, productBundleTemplateId, extractionOutputFileTemplateId, pdfPages, xlsSheets },
  ) {
    return productBundleExtractionsService
      .addProductBundleExtraction({
        name,
        opportunityDocumentId,
        productBundleTemplateId,
        extractionOutputFileTemplateId,
        pdfPages,
        xlsSheets,
      })
      .then(
        (response) => {
          commit('SUCCESS_ADDING_EXTRACTION', response);
        },
        (error) => {
          commit('ERROR', error.response);
          throw error;
        },
      );
  },
  // Delete an extraction
  deleteProductBundleExtractionById({ commit }, { id }) {
    return productBundleExtractionsService.deleteProductBundleExtractionById({ id }).then(
      (response) => {
        commit('SUCCESS_DELETING_EXTRACTION', id);
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },
  // Initiate reset of a product bundle extraction
  initiateResetProductBundleExtraction({ commit }, { id }) {
    commit('RESET_EXTRACTION', id);
  },
};

const mutations = {
  SEARCH_EXTRACTIONS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.productBundleExtractions = [];
  },
  SUCCESS(state, extractions) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    state.productBundleExtractions = extractions;
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
  SUCCESS_ADDING_EXTRACTION(state, extraction) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    state.productBundleExtractions.push(extraction);
  },
  SUCCESS_DELETING_EXTRACTION(state, id) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    state.productBundleExtractions = state.productBundleExtractions.filter((extraction) => extraction.id !== id);
  },
  RESET_EXTRACTION(state, id) {
    state.productBundleExtractions = state.productBundleExtractions.filter((extraction) => extraction.id !== id);
    state.initiateResetProductBundleExtraction = true;
  },
};

const getters = {
  productBundleExtractions: (state) => state.productBundleExtractions,
  initiateResetProductBundleExtraction: (state) => state.initiateResetProductBundleExtraction,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const productBundleExtractions = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
